import React from 'react';
import { graphql } from 'gatsby';

import styled from 'styled-components';

import { Icon } from '@keytrade/components-icon';
import { Span } from '@keytrade/components-span';

import Badge, { BadgeType } from './Badge';
import CurrencyFormatter from '@/formatters/CurrencyFormatter';
import Link, { LinkType, LinkStyle } from './Link';

export type Props = FeaturedLinkData;

export type FeaturedLinkData = {
  id: string;
  badge: BadgeType;
  link: LinkType;
  fontColor: string;
};

const FeaturedLinkContent = styled.div` 
  display: flex;
  align-items: center;
  max-width: 90%;
  > *
  {
    margin-right: 2rem;
  }
}
`;

const FeaturedLink: React.FC<Props> = ({ link, badge, fontColor }) => {
  return (
    <Link linkStyle={LinkStyle.CONTENT} {...link} promo>
      <FeaturedLinkContent>
        {badge && <Badge {...badge} />}
        <Span size='bodySm' color={fontColor} weight='bold'>
          <CurrencyFormatter>{link.linkText}</CurrencyFormatter>
        </Span>
      </FeaturedLinkContent>
      <Icon icon='icn_longArrowRight' />
    </Link>
  );
};

export default FeaturedLink;

export const featuredLinkFragmentQuery = graphql`
  fragment FeaturedLinkFragment on ContentfulFeaturedLink {
    id
    __typename
    badge {
      ...BadgeFragment
    }
    link {
      ...LinkFragment
    }
  }
`;
